import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { getUnidade } from "services/trackWork";
import { parse } from "query-string";
import { useHistory } from "react-router-dom";

const ContractContext = React.createContext({
  loading: false,
  setLoading: () => {},
  contracts: [],
  setContracts: () => {},
  selectedContract: "",
  setSelectedContract: () => {},
  load: () => {}
});

export const ContractContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [contracts, setContracts] = useState([]);
  const [selectedContract, setSelectedContract] = useState({
    nomeEmpreendimento: "",
    bloco: "",
    nomeCompletoUnidade: ""
  });
  const history = useHistory();
  const loadPromiseRef = useRef(null);

  const getSelectedContract = contractsParams => {
    const params = parse(history.location.search);
    let selected;
    if (params.contractId) {
      selected = contractsParams.find(
        contract => contract.unidadeId === params.contractId
      );
    }
    return selected || contractsParams[0];
  };

  const getContracts = async () => {
    const responseUnidade = await getUnidade();
    return responseUnidade.data.data;
  };

  const load = async () => {
    if (loadPromiseRef.current) return loadPromiseRef.current;

    loadPromiseRef.current = (async () => {
      let selected;
      try {
        const contractsInternal = await getContracts();
        selected = getSelectedContract(contractsInternal);
        setContracts(contractsInternal);
        setSelectedContract(selected);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();

    try {
      return await loadPromiseRef.current;
    } finally {
      loadPromiseRef.current = null;
    }
  };

  const value = React.useMemo(
    () => ({
      loading,
      setLoading,
      contracts,
      setContracts,
      selectedContract,
      setSelectedContract,
      load
    }),
    [contracts, loading, selectedContract]
  );

  return (
    <ContractContext.Provider value={value}>
      {children}
    </ContractContext.Provider>
  );
};

ContractContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ContractContext;
